import React, { useState } from "react";
import {
  Box, Button, TextField, Typography, Checkbox, FormControlLabel, Link
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import logo from "./component/logo/icon_new.png";
import { useTranslation } from "react-i18next";
import { login } from "./component/api/API";
import { getRole } from "./component/auth";

function LoginPage({ onLoginSuccess }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (res.status === 200) {
        const data = await res.json();
        const token = data.token;

        localStorage.setItem("token", token);
        localStorage.setItem("name", data.name);
        localStorage.setItem("role", data.role);

        const role = getRole();
        if (onLoginSuccess) onLoginSuccess(jwtDecode(token));

        // App อ่าน role ใหม่เองเมื่อ route เปลี่ยน ไม่ต้อง reload
        navigate(role === "admin" ? "/admin" : role === "user" ? "/user" : "/");
      } else {
        const data = await res.json().catch(() => ({}));
        alert(data.error || "เข้าสู่ระบบไม่สำเร็จ");
      }
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      display: "flex",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #a8e6cf 0%, #56ab2f 100%)"
    }}>
      {/* ซ้าย */}
      <Box sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: "#fff",
        p: 4
      }}>
        <Typography variant="h3" fontWeight="bold">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: '100%',
              filter: "drop-shadow(0 0 2px #2e7d32)",
            }}
          />
        </Typography>

      </Box>

      {/* เส้นแบ่ง */}
      <Box sx={{
        width: "1px",
        backgroundColor: "rgba(255,255,255,0.4)",
        my: 8
      }} />

      {/* ขวา */}
      <Box sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4
      }}>
        <Box component="form" onSubmit={handleLogin} sx={{
          width: "100%",
          maxWidth: 500,
          backgroundColor: "rgba(255,255,255,0.9)",
          p: 4,
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)"
        }}>
          <Typography variant="h5" textAlign="center" fontWeight="bold" mb={3} sx={{ color: '#2e7d32' }}>
            {t("login")}
          </Typography>

          <TextField
            fullWidth
            placeholder={t("email")}
            type="email"
            required
            margin="normal"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <TextField
            fullWidth
            placeholder={t("password")}
            type="password"
            required
            margin="normal"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />

          <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
            <FormControlLabel control={<Checkbox size="small" />} label={t("remember_me")} />
            <Link component="button" type="button" variant="body2" onClick={() => navigate("/reset-password")}>
              {t("reset_password")}
            </Link>
          </Box>

          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#66bb6a",
              "&:hover": { backgroundColor: "#4caf50" }
            }}
            type="submit"
            disabled={loading}
          >
            {loading ? t("loading") : t("login")}
          </Button>

          <Button
            fullWidth
            variant="outlined"
            sx={{ mt: 2, borderColor: "#66bb6a", color: "#388e3c" }}
            onClick={() => navigate("/signup")}
          >
            {t("signup")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;

